<sbb-history-entry
  showLine="true"
  [version]="'(' + model.nextReleaseVersion + ')'"
  [actions]="actions"
  class="publish-entry"
>
  <div class="controls-container">
    <input
      type="text"
      sbbInput
      [placeholder]="
        'app.view.variant.variant-view.variant-history.publish-entry.comment' | translate
      "
      [formControl]="comment"
    />
    <button
      sbb-button
      (click)="onPublishClicked()"
      [disabled]="publishDisabled"
      [title]="
        publishDisabled
          ? ('app.view.variant.variant-view.variant-history.publish-entry.local-changes'
            | translate)
          : ''
      "
    >
      {{ "app.view.variant.variant-view.variant-history.publish-entry.publish" | translate }}
    </button>
  </div>
</sbb-history-entry>
